import React, { useState } from "react";
import { useReportView } from "../../../../DataStore/ReportViewContext";
import ActivityLoader from "../../../Common/ActivityLoader";
import ajaxReport from "../../../../util/remote/ajaxReport";

const GeneralCommentWriter=(props)=>{
    const field = props.field;

    const [remark, setRemark] = useState(field.value!==null?field.value:"");
    const [loading, setLoading] = useState(false);
    const { generateReports } = useReportView();

    const confirmRemark=async()=>{
        if(remark.length>0)
        {   
            setLoading(true)
            const server_response = await ajaxReport.writeGeneralReportComment(
                field.id,
                remark
            );
            setLoading(false)
            if(server_response.status==="OK"){
                props.onConfirm(true)
                //refresh reports
                // generateReports(false)
            }else{

            }
        }else{
            props.onConfirm(false)
        }
    }

    return(
        <div style={{display:"flex", flexDirection:"row", justifyContent:"space-around" }}>
            <div style={{flex:3}}>
                <textarea 
                    className="ReportComments" 
                    placeholder={"Enter " + field.comment.title }
                    onChange={(e)=>{setRemark(e.target.value)}}
                    style={{width:"95%", height:"40px", maxHeight:"40px", maxWidth:"95%", minHeight:"20px", minWidth:"85%", color:"#0099E4", fontfamily:"Arial, Helvetica, sans-serif", fontSize:"14px"}} 
                    value={remark}/>
            </div>
            <div style={{flex:1}}>
                {!loading && <input 
                    type="button" 
                    value="Comment"
                    className="btn btn-sm btn-primary" 
                    style={{height:"40px"}}
                    onClick={confirmRemark}
                    />}

                 {loading && 
                 <button className="btn btn-sm btn-primary"  style={{height:"40px"}}>
                    <ActivityLoader inline size={25} color={"#FFFFFF"}/>
                 </button>
                 }
            </div>
        </div>

    )
}

export default GeneralCommentWriter;